import { RaceBy } from "@uiball/loaders";
import Flexbox from "../../components/Flexbox";
import Mode from "../../components/styles/Mode";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import requests from "../../handlers/requests";
import '../../css/form.css'
import cookies from "../../utilities/Cookies";
import { updatedarkmode } from "../../features/mode";
import { useNavigate } from "react-router-dom";
import { BuyersTYUrl, extractUTMParameters } from "../../utilities/utils";

const LeadFCDR = () => {
    const mode = useSelector(state => state.darkmode.value)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [loading, setLoading] = useState(true)

    const [error,] = useState(null)


    const sendToBuyers = (id, source, page, stop) => {
        setLoading(true)

        requests.post(`/api/${source}/fcdr`, { contact_id: id }, () => { }, () => { }, () => { }, setLoading,
            (res) => {
                const user = res.data
                const ty_page = BuyersTYUrl.get(res.buyer).replaceAll('-valid', '') // https://www.finaldebt.com/success-[buyer]-

                const full_url = `${ty_page}${page}1?first_name=${user.first_name}&last_name=${user.last_name}&debt_amount=${user.debt_amount}&phone=${user.phone}&email=${user.email}&zip=${user.zipcode}&url=${res.url ?? ''}`

                // send to buyer's thank you page
                window.location.replace(full_url)
            },
            null,
            (res) => {

                if (res.error?.includes('Duplicate')) {
                    window.location.replace(`https://www.finaldebtrelief.com/dup-error-${page}1?first_name=${res.data.first_name}&last_name=${res.data.last_name}`)
                } else if (res.msg.includes('no coverage in') || res.msg.includes('Outside')) {
                    window.location.replace(`https://www.finaldebtrelief.com/dq-${page}1?first_name=${res.data.first_name}&last_name=${res.data.last_name}`)
                } else {
                    navigate(`/turbo-form`, { replace: true })
                }
            }
        )
    }


    useEffect(() => {
        cookies.setCookies('mode', 'light', 10)
        dispatch(updatedarkmode({ dark: false }))

        const urlParams = new URLSearchParams(window.location.search)
        const contact_id = urlParams.get('contact_id')
        const source = urlParams.get('source')

        sendToBuyers(contact_id, source, 'lf', false)
        // eslint-disable-next-line
    }, [])

    return (
        <Mode>
            <div className="turbo-debt-page">
                {loading && <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                    <RaceBy size={40} speed={0.9} color={mode.dark ? "white" : "black"} />
                </Flexbox>}
                {error && (
                    <div>
                        <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                            {error}
                        </Flexbox>
                    </div>
                )}
            </div>
        </Mode>
    );
}

export default LeadFCDR;